'use client';

import { observer } from 'mobx-react-lite';

import CatalogPage from '@features/marketplace/catalog/CatalogPage';
import { productCatalog } from 'helpers/fakeData';
import { useStores } from 'stores/rootStore';

const AllProductsPage = () => {
  const { marketPlaceStore } = useStores();
  const products = marketPlaceStore.filterProducts(productCatalog);
  return <CatalogPage products={products} />;
};

export default observer(AllProductsPage);
